const ThisIsJustToSay = (props) => {
    return (
        <div className="lyrics">
            <h2>This is just to say</h2>
            <h4>William Carlos Williams</h4>
            <p>I have eaten<br/>
                the plums<br/>
                that were in<br/>
                the icebox<br/>
                <br/>
                and which<br/>
                you were probably<br/>
                saving<br/>
                for breakfast<br/>
                <br/>
                Forgive me<br/>
                they were delicious<br/>
                so sweet<br/>
                and so cold<br/>
                <br/>
            <small>Reprinted with permission of New Directions Publishing.<br/>&copy;New Directions Publishing. All Rights Reserved</small>
            </p>
        </div>
    )
}
export default ThisIsJustToSay;